import { Box, Switch, Typography } from '@coolblue-development/freddy';
import { useEmailContext } from '../../../../contexts/EmailContext';

const EmailViewTimerToggle = (): JSX.Element => {
  const { isEmailViewTimerEnabled, setEmailViewTimerEnabled } = useEmailContext();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
      <Box>
        <Typography fontWeight={600}>Email timer</Typography>
        <Typography variant="caption">
          Shows the total time you have spent on an email contact. It pauses when you are on a call, open a different
          channel or email contact.
        </Typography>
      </Box>
      <Switch
        aria-label="Email timer"
        data-testid="email-view-timer-switch"
        checked={isEmailViewTimerEnabled}
        onChange={setEmailViewTimerEnabled}
      />
    </Box>
  );
};

export default EmailViewTimerToggle;
